import React from "react";
import { Controller } from "react-hook-form";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

const NewControlledTextFieldSeparatedLabel = ({
	control,
	defaultValue,
	name,
	label,
	error,
	errorMessage,
	shrinkLabel = true,
	startAdornment,
	endAdornment,
	labelStyles,
	inputStyles,
	...rest
}) => {
	return (
        <Controller
			control={control}
			name={name}
			defaultValue={defaultValue && defaultValue}
			render={({ field: { onChange, value } }) => (
				<Box
					sx={{
						display: "flex",
						gap: "10px",
						alignItems: "center",
						width: "100%",
					}}
				>
					<Box
						sx={{
							flex: "0",
							display: "flex",
							alignItems: "center",
							height: "100%",
							...(rest.multiline && { alignSelf: "start" }),
							...labelStyles,
						}}
					>
						<Typography
							variant="label"
							component="label"
							htmlFor="bootstrap-input"
							color={error && "error"}
							sx={{
								whiteSpace: "nowrap",
								margin: rest.margin === "none" ? "0" : "16px 0 8px 0",
							}}
						>
							{label}:
						</Typography>
					</Box>
					<Box
						sx={{
							flex: "1",
							display: "flex",
							alignItems: "center",
							...inputStyles,
						}}
					>
						<TextField
                            id="bootstrap-input"
                            size="small"
                            value={value}
                            variant="outlined"
                            fullWidth
                            onChange={onChange}
                            error={error}
                            helperText={errorMessage ? errorMessage : ""}
                            {...rest}
                            slotProps={{
                                input: {
                                    startAdornment: startAdornment,
                                    endAdornment: endAdornment,
                                },

                                inputLabel: { shrink: shrinkLabel }
                            }} />
					</Box>
				</Box>
			)}
		></Controller>
    );
};

export default NewControlledTextFieldSeparatedLabel;
